export default __webpack_public_path__ + "static/media/3-3.e38ffdd9.png";